import React, { useState, Fragment } from "react";
import { Popover, PopoverButton, PopoverPanel, Transition } from "@headlessui/react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import {
  PlusIcon,
  UserGroupIcon,
  PhoneIcon,
  EnvelopeIcon,
} from "@heroicons/react/24/outline";
import { useContacts } from "hooks/useContacts";
import AssignContactsToLeadModal from "./AssignContactsToLeadModal";
import { formatNumber } from "utils/formatNumber";

export default function LeadDrawerContacts({
  leadId,
  leadData,
  onRefresh,
  onViewContactsTab,
  hideTabs = false,
}) {
  const { contacts: assignedContacts, refresh: refreshContacts } = useContacts(leadId);
  const [isAssignContactModalOpen, setIsAssignContactModalOpen] = useState(false);
  const [contactModalMode, setContactModalMode] = useState("new");

  const handleAssigned = () => {
    refreshContacts();
    if (onRefresh) onRefresh();
    setIsAssignContactModalOpen(false);
  };

  const leadName = leadData?.FullName || leadData?.name || leadData?.LeadName || "Unknown User";
  const phoneNumber = leadData?.PhoneNumber || "N/A";
  const emailAddress = leadData?.EmailId || leadData?.email || "N/A";

  const assignLeadDetails = leadData
    ? {
      fullName: leadName === "Unknown User" ? "" : leadName,
      email: emailAddress === "N/A" ? "" : emailAddress,
      phoneNumber: phoneNumber === "N/A" ? "" : phoneNumber,
      ...leadData,
    }
    : null;
  if (assignedContacts && assignedContacts.length === 0) {
    return;
  }

  return (
    <div
      className={`${hideTabs ? "flex justify-end" : "flex justify-between"
        } flex-wrap items-center gap-x-4 gap-y-2 pt-2.5 mt-2.5 border-t border-gray-100 dark:border-dark-800 text-[12px] text-gray-600 dark:text-dark-300 -mx-5 px-6`}
    >
      <div className="flex flex-col gap-1 min-w-0 flex-1">
        <span className="text-[10px] font-semibold text-gray-500 dark:text-dark-400 uppercase tracking-wide">
          Contacts
        </span>
        <div className="flex items-stretch gap-1.5 flex-wrap">
          {assignedContacts &&
            assignedContacts.length > 0 &&
            assignedContacts.slice(0, 2).map((contact, idx) => {
              const name = contact.FullName || contact.fullName || contact.name || "Unknown";
              const phone = contact.PhoneNumber || contact.phoneNumber;
              const email = contact.Email || contact.email;
              return (
                <div
                  onClick={() => { onViewContactsTab() }}
                  key={contact.id || contact.ContactId || contact.Id || idx}
                  className="flex flex-col gap-1 px-3 py-1.5 rounded-lg bg-blue-50/50 hover:bg-blue-100/50 dark:bg-blue-950/20 hover:dark:bg-blue-950/35 border border-blue-200/60 dark:border-blue-900/40 text-[10px] sm:text-[11px] shrink-0 cursor-pointer transition-all duration-200"
                >
                 {name && <div className="flex items-center gap-1.5 font-bold text-blue-900 dark:text-blue-200">
                    <UserGroupIcon className="w-3.5 h-3.5 text-blue-600 dark:text-blue-400 shrink-0" />
                    <span>{name || "Unknown"}</span>
                  </div>}
                  {formatNumber(phone) && (
                    <div className="flex items-center gap-1.5 font-semibold text-gray-800 dark:text-gray-200 whitespace-nowrap">
                      <PhoneIcon className="w-3.5 h-3.5 text-blue-600 dark:text-blue-400 shrink-0" />
                      <span>{formatNumber(phone) || "N/A"}</span>
                    </div>
                  )}
                  {email && (
                    <div className="flex items-center gap-1.5 font-semibold text-gray-800 dark:text-gray-200 whitespace-nowrap">
                      <EnvelopeIcon className="w-3.5 h-3.5 text-blue-600 dark:text-blue-400 shrink-0" />
                      <span title={email}>{email || "N/A"}</span>
                    </div>
                  )}
                </div>
              );
            })}

          {assignedContacts && assignedContacts.length > 2 && (
            <button
              onClick={onViewContactsTab}
              className="flex items-center justify-center px-2.5 rounded-lg bg-blue-50/60 hover:bg-blue-100 dark:bg-blue-950/20 border border-blue-200/50 dark:border-blue-900/30 text-[10px] font-bold text-blue-700 dark:text-blue-400 transition-all duration-200 cursor-pointer active:scale-95 shrink-0 self-stretch"
            >
              +{assignedContacts.length - 2}
            </button>
          )}
        </div>
      </div>

      {/* <Popover className="relative self-center">
        <PopoverButton className="inline-flex items-center gap-1 rounded-md bg-primary-600 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 transition-colors cursor-pointer">
          <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" />
          Contact
        </PopoverButton>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-1"
        >
          <PopoverPanel className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white dark:bg-dark-800 shadow-lg ring-1 ring-black/5 focus:outline-none">
            {({ close }) => (
              <div className="py-1">
                <button
                  onClick={() => {
                    setContactModalMode("new");
                    setIsAssignContactModalOpen(true);
                    close();
                  }}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-700 transition-colors"
                >
                  New Contact
                </button>
                <button
                  onClick={() => {
                    setContactModalMode("existing");
                    setIsAssignContactModalOpen(true);
                    close();
                  }}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-700 transition-colors"
                >
                  Existing Contact
                </button>
              </div>
            )}
          </PopoverPanel>
        </Transition>
      </Popover> */}

      <AssignContactsToLeadModal
        isOpen={isAssignContactModalOpen}
        onClose={() => setIsAssignContactModalOpen(false)}
        leadId={leadId}
        initialMode={contactModalMode}
        onAssigned={handleAssigned}
        hasAssignedContacts={assignedContacts && assignedContacts.length > 0}
        leadDetails={assignLeadDetails}
      />
    </div>
  );
}
